export enum DragType {
  Piece = "piece"
}


// WEBPACK FOOTER //
// ./src/constants.ts